/**
 * Mapas de color ESTÁTICOS para clases de Tailwind.
 *
 * Tailwind JIT no puede ver clases construidas con template-literals
 * (`bg-${c}-500`), así que esas clases nunca se generan y el elemento queda
 * SIN color. Este módulo expone los strings de clase completos —visibles para
 * el compilador— para los patrones categóricos que la app usa (badges de modo,
 * iconos de stats, chips de dificultad, badges de rol).
 *
 * Reglas:
 *  - Los colores aquí son CATEGÓRICOS (distinguen datos: modo, dificultad,
 *    rol), no el acento de marca. El acento decorativo/interactivo va por
 *    `--primary` (naranja ONOR), no por estos mapas.
 *  - Si llega un color no mapeado, se cae a un neutro (zinc) legible.
 */

// text-{c}-400 — para iconos y texto categórico.
const TEXT_400 = {
  cyan: 'text-cyan-400',
  emerald: 'text-emerald-400',
  amber: 'text-amber-400',
  purple: 'text-purple-400',
  red: 'text-red-400',
  blue: 'text-blue-400',
  green: 'text-green-400',
  orange: 'text-orange-400',
  zinc: 'text-zinc-400',
};

// Badge suave: bg-{c}-500/10 + text-{c}-400 + border-{c}-500/30.
const BADGE_SOFT = {
  cyan: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/30',
  emerald: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  amber: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
  purple: 'bg-purple-500/10 text-purple-400 border-purple-500/30',
  red: 'bg-red-500/10 text-red-400 border-red-500/30',
  blue: 'bg-blue-500/10 text-blue-400 border-blue-500/30',
  green: 'bg-green-500/10 text-green-400 border-green-500/30',
  orange: 'bg-orange-500/10 text-orange-400 border-orange-500/30',
  zinc: 'bg-zinc-500/10 text-zinc-400 border-zinc-500/30',
};

// Chip seleccionado: bg-{c}-500/20 + border-{c}-500 + text-{c}-400.
const CHIP_SELECTED = {
  cyan: 'bg-cyan-500/20 border-cyan-500 text-cyan-400',
  emerald: 'bg-emerald-500/20 border-emerald-500 text-emerald-400',
  amber: 'bg-amber-500/20 border-amber-500 text-amber-400',
  purple: 'bg-purple-500/20 border-purple-500 text-purple-400',
  red: 'bg-red-500/20 border-red-500 text-red-400',
  blue: 'bg-blue-500/20 border-blue-500 text-blue-400',
  green: 'bg-green-500/20 border-green-500 text-green-400',
  orange: 'bg-orange-500/20 border-orange-500 text-orange-400',
  zinc: 'bg-zinc-500/20 border-zinc-500 text-zinc-400',
};

// Badge sólido suave: bg-{c}-500/20 + text-{c}-400 (roles admin).
const BADGE_SOLID = {
  cyan: 'bg-cyan-500/20 text-cyan-400',
  emerald: 'bg-emerald-500/20 text-emerald-400',
  amber: 'bg-amber-500/20 text-amber-400',
  purple: 'bg-purple-500/20 text-purple-400',
  red: 'bg-red-500/20 text-red-400',
  blue: 'bg-blue-500/20 text-blue-400',
  green: 'bg-green-500/20 text-green-400',
  orange: 'bg-orange-500/20 text-orange-400',
  zinc: 'bg-zinc-500/20 text-zinc-400',
};

// Fondo tenue: bg-{c}-500/10 — contenedores de icono.
const BG_TINT = {
  cyan: 'bg-cyan-500/10',
  emerald: 'bg-emerald-500/10',
  amber: 'bg-amber-500/10',
  purple: 'bg-purple-500/10',
  red: 'bg-red-500/10',
  blue: 'bg-blue-500/10',
  green: 'bg-green-500/10',
  orange: 'bg-orange-500/10',
  zinc: 'bg-zinc-500/10',
};

export const textColor = (c) => TEXT_400[c] || TEXT_400.zinc;
export const bgTint = (c) => BG_TINT[c] || BG_TINT.zinc;
export const badgeSoft = (c) => BADGE_SOFT[c] || BADGE_SOFT.zinc;
export const chipSelected = (c) => CHIP_SELECTED[c] || CHIP_SELECTED.zinc;
export const badgeSolid = (c) => BADGE_SOLID[c] || BADGE_SOLID.zinc;
